export default __webpack_public_path__ + "assets/images/996027d6c872080ca61ca7ec80ff19ae.jpg";